// extracted by mini-css-extract-plugin
module.exports = {"headerBox":"Title_headerBox__2UHUV"};